import React from "react";

export default function EndOfConversation() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
      }}
    >
      <p style={{ fontWeight: "bold" }}>Start Of Conversation</p>
    </div>
  );
}
